import Logo from '../assets/img/logo-48.png';
import { Link } from 'react-router-dom';

const Header = () => {
  return (
    <header className='Header'>
      <img src={Logo} alt="" />
      <h4>Exacthours</h4>
      <div className='d-flex gap-3 justify-content-center'>
        <div><Link to="/">Home</Link></div>
        <div><Link to="/hussain">Hus</Link></div>
        <div><Link to="/badusha">Bad</Link></div>
      </div>
    </header>
  )
}

export default Header;